import { NgModule } from '@angular/core';
import { PhBhpChcConfigureComponent } from './ph-bhp-chc-configure/ph-bhp-chc-configure.component';

import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';

// common libraries


import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChcComponent } from './chc/chc.component';
import {NgxMaskModule} from 'ngx-mask';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
// tslint:disable-next-line:max-line-length
// tslint:disable-next-line:max-line-length
@NgModule({
  declarations: [
    ChcComponent,
    PhBhpChcConfigureComponent
  ],
  imports: [
    PHBHPLayoutPackageModule,
    PHBHPLocalizePackageModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    PhBhpUiModule
  ]
})
export class PHBHPFeaturePackageChcModule { }
